// Resolves the runtime feature flags / site settings that control image
// compression on the upload path into a compression mode and quality value.
import Cookies from 'js-cookie';

// The upload path's compression modes.
export const CompressionMode = Object.freeze({
  BEAMR: 'beamr',
  BROWSER: 'browser',
  NONE: 'none',
});

// Pre-release testing: set this cookie (any value) to force browser compression on a
// specific browser even when Beamr is enabled.
export const FORCE_BROWSER_COMPRESSION_COOKIE = 'pb_force_browser_comp';

// Compression mode precedence: the force cookie wins over everything; then Beamr
// over browser; browser only when Beamr is off; otherwise no compression.
export const resolveCompressionMode = (win = window) => {
  if (Cookies.get(FORCE_BROWSER_COMPRESSION_COOKIE) !== undefined) {
    return CompressionMode.BROWSER;
  }
  if (win.beamrCompressionEnabled) return CompressionMode.BEAMR;
  if (win.features && win.features.browserImageCompression) {
    return CompressionMode.BROWSER;
  }

  return CompressionMode.NONE;
};

// browser_compression_level (site setting) is a 0-1 JPEG quality value.
// Reject anything out of range so the compressor falls back to its print-grade default.
export const resolveCompressionQuality = (win = window) => {
  const level = Number(win.features?.browserCompressionLevel);
  return level > 0 && level <= 1 ? level : undefined;
};

// How many images compress at once, bounding peak decode memory. Kept low and
// independent of the upload window (number of concurrent uploads). 2 keeps the
// peak modest, which matters most on the main-thread fallback path (e.g. iOS
// < 16.4, which has no OffscreenCanvas in a worker).
export const DEFAULT_COMPRESSION_CONCURRENCY = 2;

// browser_compression_concurrency can override the default; any
// missing / non-positive value falls back to it.
export const resolveCompressionConcurrency = (win = window) => {
  const override = Number(win.features?.browserCompressionConcurrency);

  return override > 0 ? override : DEFAULT_COMPRESSION_CONCURRENCY;
};
